import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";
// import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {
  ErrorOutline as ErrorOutlineIcon,
  Logout as LogoutIcon,
} from "@mui/icons-material";
import { AppButton } from "components/common/buttons";

const Unauthorized = () => {
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate("/login");
  };
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="80vh"
      p={3}
    >
      <Paper
        elevation={3}
        sx={{
          p: 4,
          textAlign: "center",
          maxWidth: 500,
          width: "100%",
        }}
      >
        <ErrorOutlineIcon color="error" sx={{ fontSize: 64, mb: 2 }} />

        <Typography variant="h4" gutterBottom color="error">
          Không có quyền truy cập
        </Typography>

        <Typography variant="body1" color="textSecondary" paragraph>
          Bạn không có quyền truy cập vào trang này. Vui lòng liên hệ với quản
          trị viên để được cấp quyền truy cập phù hợp.
        </Typography>

        <Typography variant="body2" color="textSecondary" paragraph>
          Nếu bạn tin rằng đây là lỗi, vui lòng thử đăng nhập lại hoặc liên hệ
          với bộ phận hỗ trợ kỹ thuật.
        </Typography>

        <Box mt={3} display="flex" justifyContent="center" gap={2}>
          <Button
            variant="contained"
            color="primary"
            component={Link}
            to="/projects"
          >
            Về trang chủ
          </Button>

          {/* <Button variant="outlined" onClick={handleLogout}>
            Đăng xuất
          </Button> */}
          <AppButton
            variant="outlined"
            color="error"
            onClick={handleLogout}
            startIcon={<LogoutIcon />}
          >
            Đăng xuất
          </AppButton>
        </Box>
      </Paper>
    </Box>
  );
};

export default Unauthorized;
